import { useEffect, useState } from 'react';
import { PopupTypeEnum } from '../../../enums/popupTypeEnum';
import axios from '../../../lib/axios';
import { PopupModel } from '../../../models/popup';
import { DEFAULT_ROWS_PER_PAGE } from '../../../config-global';
import { numberFormat } from '../../../utils/nunberFormat';
import { DELETE_POPUP } from '../../../lib/endpoints/advertise';
import { StatusEnum } from '../../../enums/status';

import { useTranslation } from 'react-i18next';
import { getAllTagPromotion } from '../../../services/tagPromotion';
import { TagPromotionModel } from '../../../models/tagPromotion.model';
import { getMerchantData } from '../../../services/merchant';
import { MerChantModel } from '../../../models/merChantModel';
import { useSelector } from 'react-redux';
import { RootState } from '../../../store';
import { getAllPopupSlideService } from '../../../services/popup';

export const usePopUpManageControllers = () => {
  const { t } = useTranslation('global');
  const [tabPopupType, setTabPopupType] = useState<PopupTypeEnum>(PopupTypeEnum.LANDING_PAGE);
  const [tabStatus, setTabStatus] = useState<StatusEnum>(StatusEnum.ALL);
  const [tabActiveValue, setTabActiveValue] = useState<boolean>(true);

  const [openMenu, setOpenMenu] = useState(null);
  const [openForm, setOpenForm] = useState<boolean>(false);
  const [currentPage, setCurrentPage] = useState<number>(1);

  const [data, setData] = useState<PopupModel[]>([]);
  const [tagPromotionData, setTagPromotionData] = useState<TagPromotionModel[]>([]);
  const [merchantData, setMerchantData] = useState<MerChantModel[]>([]);
  const [loadingData, setLoadingData] = useState<boolean>(false);
  const [loadingPage, setLoadingPage] = useState<boolean>(false);

  const [loadingDelete, setLoadingDelete] = useState<boolean>(false);
  const [openDeleteDialog, setOpenDeleteDialog] = useState<boolean>(false);
  const [selectedId, setSelectedId] = useState<string>('');
  const [selectedData, setSelectedData] = useState<PopupModel>(null!);

  const adminRole = useSelector((state: RootState) => state.auth?.data?.role?.role_type);
  const assignMerchantToAdmin = useSelector((state: RootState) => state?.auth?.data?.merchants);

  //function

  const handleFetchData = async (type: PopupTypeEnum) => {
    try {
      setData([]);
      setLoadingData(true);
      const branchResponse = await getMerchantData();
      const resGetPopup: PopupModel[] = await getAllPopupSlideService({ limit: 100 });

      if (branchResponse?.length > 0) {
        const matchingMerchants = branchResponse.filter((merchant: any) =>
          assignMerchantToAdmin?.includes(merchant?.id)
        );
        if (adminRole === 'SUPER_ADMIN') {
          setMerchantData(branchResponse);
        } else if (adminRole === 'ADMIN' && matchingMerchants.length > 0) {
          setMerchantData(matchingMerchants);
        }
      }
      if (resGetPopup?.length > 0) {
        const popupData: any = resGetPopup?.map((item: PopupModel) => {
          const populateBranch: MerChantModel[] = branchResponse?.filter(
            (sub: MerChantModel) => sub.id === item?.id
          );
          return {
            ...item,
            branch: populateBranch.length > 0 ? populateBranch[0] : null,
          };
        });
        setData(popupData);
      }
    } catch (err) {
      console.error('Error fetching data:', err);
      window.alert('Error fetching data. Please try again later.');
    } finally {
      setLoadingData(false);
    }
  };

  const handleGetData = async () => {
    try {
      setLoadingPage(true);
      handleFetchData(tabPopupType);
      const resMerchant = await getMerchantData();
      const resTagPro = await getAllTagPromotion();
      setTagPromotionData(resTagPro);
      setMerchantData(resMerchant);
    } catch (err) {
      console.error('Error fetching data:', err);
    } finally {
      setLoadingPage(false);
    }
  };

  const handleGetTagPromotionData = async (): Promise<void> => {
    try {
      setLoadingData(true);
      const response = await getAllTagPromotion();
      const tagData = response;

      if (Array.isArray(tagData) && tagData.length > 0) {
        setTagPromotionData(tagData);
      } else {
        setTagPromotionData([]);
      }
    } catch (error) {
      console.error('Error fetching tag promotions:', error);
    } finally {
      setLoadingData(false);
    }
  };

  const handleDeleteData = async () => {
    try {
      setLoadingDelete(true);
      await axios.delete(DELETE_POPUP + selectedId);
      setData(data?.filter((item) => item?.id !== selectedId));
      setOpenDeleteDialog(false);
    } catch (err: any) {
      try {
        window.alert(err.response.data.message);
      } catch (err2) {
        window.alert(t('popup_page.Server error please try again'));
      }
    } finally {
      setLoadingDelete(false);
    }
  };

  const handleAddDataSuccess = (addedData: PopupModel) => {
    setData([addedData, ...data]);
    setOpenForm(false);
  };

  const handleUpdateSuccess = (updateData: PopupModel) => {
    setData(
      data?.map((item) => {
        if (item?.id === updateData?.id) {
          return updateData;
        } else {
          return item;
        }
      })
    );
    setOpenForm(false);
  };

  const handleOpenForm = () => {
    setOpenForm(true);
    setSelectedData(null!);
  };

  const handleCloseForm = () => {
    setOpenForm(false);
    setOpenMenu(null);
    setSelectedData(null!);
  };

  const handleClickDeleteButton = () => {
    setOpenMenu(null);
    setOpenDeleteDialog(true);
  };

  const handleClickEditButton = () => {
    setOpenMenu(null);
    setOpenForm(true);
    if (selectedId) {
      setSelectedData(data?.filter((item) => item?.id === selectedId)[0]);
    }
  };

  const onOpenMenu = (event: any, getId: string) => {
    setOpenMenu(event.currentTarget);
    setSelectedId(getId);
  };

  const onCloseMenu = () => { setOpenMenu(null) };

  // ----------------------------------------------
  
  const filterDataByType: PopupModel[] = data?.filter((item: PopupModel) => item?.type === tabPopupType);

  const filterDataByStatus: PopupModel[] = filterDataByType?.filter((item: PopupModel) =>
    tabStatus === StatusEnum.ALL
      ? true
      : tabStatus === StatusEnum.ACTIVE
      ? item?.isActive === true
      : item?.isActive === false
  );

  const countPagination = Math.ceil(filterDataByStatus?.length / DEFAULT_ROWS_PER_PAGE);
  const rows: PopupModel[] = filterDataByStatus?.slice(
    (currentPage - 1) * DEFAULT_ROWS_PER_PAGE,
    currentPage * DEFAULT_ROWS_PER_PAGE
  );

  // use Effect
  useEffect(() => {
    handleGetData();
    handleGetTagPromotionData();
  }, []);

  return {
    data,
    rows,
    currentPage,
    countPagination,
    tabPopupType,
    openMenu,
    openForm,
    tabStatus,
    selectedData,
    loadingDelete,
    openDeleteDialog,
    tabActiveValue,
    tagPromotionData,
    loadingData,
    loadingPage,
    merchantData,
    filterDataByType,
    handleOpenForm,
    handleCloseForm,
    onOpenMenu,
    onCloseMenu,
    handleClickDeleteButton,
    handleClickEditButton,
    handleAddDataSuccess,
    handleUpdateSuccess,
    handleGetData,
    handleDeleteData,
    handleSetOpenDeleteDialog: (newValue: boolean) => setOpenDeleteDialog(newValue),
    handleTabPopupTypeChange: (newValue: PopupTypeEnum) => setTabPopupType(newValue),
    handleTabActiveChange: (newValue: boolean) => setTabActiveValue(newValue),
    handlePageChange: (event: any, newPage: any) => setCurrentPage(newPage),
    handleCountIndex: (index: number) => numberFormat(index + 1 + DEFAULT_ROWS_PER_PAGE * (currentPage - 1)),
    handleSetTabStatus: (newValue: StatusEnum) => {
      setTabStatus(newValue);
      setCurrentPage(1);
    },
  };
  
};
